<template>
	<main v-if="currentPage" class="single event main" :key="currentPageID" :class="'type-' + currentPostType">
		<template v-if="!isProtected">
			<PageHeader is-event />
			<ModuleBuilder />
			<div class="content-padding">
				<RelatedArticles
					:connected="true"
					v-if="connectedPosts"
					class="related-events-post no-padding-top margin-top-xl"
					:data="connectedPosts"
				/>
			</div>
			<SocialShareArticle />

			<div class="content-padding">
				<RelatedEvents
					related="true"
					v-if="relatedEventsData"
					class="related-events-post no-padding-top margin-top-xl"
					:data="relatedEventsData"
				/>
			</div>
		</template>
		<PasswordProtection v-else />
	</main>
</template>

<script>
import moment from 'moment'
moment.locale('nb-NO')

import ModuleBuilder from '@/components/ModuleBuilder'
import RelatedEvents from '@/components/modules/Events'
import RelatedArticles from '@/components/modules/Articles'
import SocialShareArticle from '@/components/elements/SocialShareArticle'
import PasswordProtection from '@/components/parts/PasswordProtection'
import WpImage from '@/components/elements/WpImage'
import PageHeader from '@/components/parts/PageHeader'

import { mapGetters } from 'vuex'

export default {
	name: 'single-post',
	components: {
		ModuleBuilder,
		PasswordProtection,
		SocialShareArticle,
		RelatedEvents,
		WpImage,
		PageHeader,
		RelatedArticles,
		//RelatedEvents,
	},
	data() {
		return {
			eventDatetime: '',
		}
	},
	created() {
		this.eventDatetime = this.currentPage.acf.event_datetime ? moment(this.currentPage.acf.event_datetime) : false
	},
	computed: {
		...mapGetters(['currentPageID', 'currentPage', 'currentPostType', 'getOptions']),
		connectedPosts() {
			if (!this.currentPageID) return null
			return {
				post_to_event: this.currentPageID,
			}
		},
		relatedEventsData() {
			if (!this.currentPageID) return null
			//let taxonomy = 'category';
			let select_category = this.currentPage.acf.category || 'any'
			let title = 'Related events'

			return {
				title,
				limit: 3,
				exclude: [this.currentPageID],
				category: select_category,
			}
		},

		isProtected() {
			let isProtected = false
			if (this.currentPage && this.currentPage.is_protected === true) {
				isProtected = true
			}
			return isProtected
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.single.event {
	.featured-image-event {
		div.image.item,
		div.image {
			padding: 0;
			height: 650px;
			@include mquery($tablet) {
				height: 500px;
			}
			@include mquery($phone) {
				height: 400px;
			}
		}
	}
	.cat-container {
		display: flex;
		justify-content: center;
	}
	.post-img-hold {
		margin-bottom: 122px;
		overflow: visible;
	}
	.cat-indi {
		background: var(--eventColor, var(--pink));
		@include mquery($phone) {
			margin-top: 10px;
		}
	}
	.title-container {
		display: flex;
		align-items: flex-end;
		@include mquery($phone) {
			display: block;
			svg {
				width: 161px * 0.7;
				height: 100px * 0.7;
			}
		}
		h1 {
			left: -107px * 0.75;
			position: relative;
			margin-top: 0;
			max-width: 700px;
			margin-left: auto;
			margin-right: auto;
			text-align: center;
			@include mquery($tablet) {
				left: 0;
			}
		}
	}
}
</style>
